// 德文
import twLocale from 'element-ui/lib/locale/lang/de'

export default {
  ...twLocale
}
